/*
 * Tap a size on a product card → that size goes into the cart.
 *
 * The "+" on the same strip still opens the quick-add modal
 * (snippets/quick-add-popup.liquid) for photos and details; a size button is
 * for the customer who already knows what they want and should not have to
 * open anything to buy it.
 *
 * Delegated from `document`, because the infinite scroll keeps appending
 * cards and a per-button listener would miss every page after the first.
 */
import { enqueue, announce, track } from '@theme/cp-ladder-ui';

const root = function () { return window.Shopify?.routes?.root || '/'; };

function addVariant(variantId, button) {
  button.classList.add('is-busy');
  const sizeLabel = button.textContent.trim().toUpperCase();
  // The photo starts flying on the tap itself; the notice waits for the cart.
  if (window.cpFly) window.cpFly(button);

  return enqueue(function () {
    return fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
    })
      .then(function (response) {
        if (!response.ok) {
          // The size on the card has no error slot of its own: say it in a
          // toast, in Ukrainian (cp-errors.js), instead of failing silently.
          return response.json().catch(function () { return {}; }).then(function (data) {
            if (window.cpToast) window.cpToast(data.description || data.message);
            throw new Error('add.js → ' + response.status);
          });
        }
        return fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } });
      })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        // The drawer, the header count, the banner and the ladder all redraw
        // from this one event.
        announce(cart, 'cp-card-size');
        if (window.cpAdded) window.cpAdded(button, sizeLabel, true);

        button.classList.remove('is-busy');
        button.classList.add('is-done');
        const label = button.textContent;
        button.textContent = '✓';
        setTimeout(function () {
          button.classList.remove('is-done');
          button.textContent = label;
        }, 1400);
      })
      .catch(function (error) {
        button.classList.remove('is-busy');
        throw error;
      });
  });
}

/* A struck-out size on a card opens the chat: "Повідомити про наявність".
 * The URL is the same theme setting the product page uses (cp_help_url). */
document.addEventListener('click', function (event) {
  const out = event.target.closest('.minimal-card-size.is-out[data-cp-notify-size]');
  if (!out) return;
  event.preventDefault();
  event.stopPropagation();
  let help = null;
  try { help = JSON.parse(document.getElementById('cp-ladder-config').textContent).helpUrl; } catch (e) {}
  if (!help) return;
  window.open(help, '_blank', 'noopener');
  track('cp_notify_click', { size: out.dataset.cpNotifySize, source: 'card' });
}, true);

document.addEventListener('click', function (event) {
  const size = event.target.closest('.minimal-card-size[data-variant-id]');
  if (!size) return;

  /* The strip sits over the product link; without this the tap would also
   * open the product page. */
  event.preventDefault();
  event.stopPropagation();
  if (size.disabled || size.classList.contains('is-busy')) return;

  addVariant(Number(size.dataset.variantId), size);
});
